export default {
  name: "User",
  plural: "Users",
};
